import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_multiselect = _resolveComponent("multiselect")!

  return (_openBlock(), _createBlock(_component_multiselect, {
    id: "per-page-selector",
    modelValue: _ctx.store.state.pagination.perPage,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.store.state.pagination.perPage) = $event)),
    options: _ctx.pageOptions,
    placeholder: _ctx.$t('shared.pagination.page_amount'),
    "show-labels": false,
    "allow-empty": false,
    class: "per-page-selector"
  }, null, 8, ["modelValue", "options", "placeholder"]))
}